import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=063c1a92&"
import script from "./Carousel.vue?vue&type=script&lang=js&"
export * from "./Carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/benutzer/Desktop/401/Phywe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('063c1a92')) {
      api.createRecord('063c1a92', component.options)
    } else {
      api.reload('063c1a92', component.options)
    }
    module.hot.accept("./Carousel.vue?vue&type=template&id=063c1a92&", function () {
      api.rerender('063c1a92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/phywe/Carousel.vue"
export default component.exports